export default "__VITE_ASSET__0f14f41c__"